import {Component, HostListener, Inject, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {EditDialogComponent} from '../../../../../admin/components/server-configuration/edit-dialog/edit-dialog.component';
import {Utils} from '../../../../../../common/services/Utils';
import {TranslateService} from '@ngx-translate/core';
import {Language} from '../../../../../../common/models/language';
import {LangChange} from '../../../../../../lang-change';
import {CenterProfession} from '../center-profession';
import {CenterProfessionService} from '../../../../../../common_services/center-profession.service';
import {ProfessionTypeService} from '../../../../../../common_services/profession-type.service';
import {MultiLang} from '../../../../../admin/models/multiLang';
import {ModuleENUM} from '../../../../../../common/enums/module.enum';
import {ModuleExtendedEdit} from '../../../../../../common/enums/module-extended-edit.enum';
import {Principal} from '../../../../../../common/services/principal';

@Component({
  selector: 'app-center-profession-dialog',
  templateUrl: './center-profession-dialog.component.html',
  styleUrls: ['./center-profession-dialog.component.scss']
})
export class CenterProfessionDialogComponent extends LangChange implements OnInit {

  form: FormGroup;
  profession: CenterProfession;
  professionTypeList: MultiLang[];
  hasWriteAccess = false;

  constructor(protected translateService: TranslateService,
              private _dialogRef: MatDialogRef<EditDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private utils: Utils,
              private _principal: Principal,
              private _professionTypeService: ProfessionTypeService,
              private _centerProfessionService: CenterProfessionService) {
    super(translateService);
  }

  ngOnInit() {
    this.hasWriteAccess = this._principal.isAdmin() ||
      (this._principal.hasWriteAccess(ModuleENUM.DICTIONARY) && this._principal.hasModuleExtendedEdit(ModuleENUM.DICTIONARY, ModuleExtendedEdit.DATA_EDIT));
    if (this.data.id == 0) {
      this.profession = new CenterProfession();
    } else {
      this._centerProfessionService.getById(this.data.id).subscribe(
        data => {
          this.profession = data;
        }
      );
    }
    this.initProfessionTypeList();
  }

  initProfessionTypeList(): void {
    this._professionTypeService.getAll().subscribe(
      data => {
        this.professionTypeList = data;
        Language.updateListLocalizedName(this.professionTypeList);
      }
    );
  }

  onSubmit() {
    this._centerProfessionService.save(this.profession).subscribe(
      data => {
        if (data.description === 'isUsed') {
          this.utils.notifyError(this.translateService.instant('profession_code_is_used'), null);
        } else {
          this.utils.notifySuccess(this.translateService.instant('saved'), null);
          this._dialogRef.close();
        }
      },
      error => {
        console.error(error);
        this.utils.notifyError(this.translateService.instant('error_occurred'), null);
      }
    );
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this._dialogRef.close();
  }

  closeDialog(): void {
    this._dialogRef.close();
  }

  onLangChange(langCode): void {
    Language.updateListLocalizedName(this.professionTypeList);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/dictionary/profession/edit/center-profession-dialog.component.ts